<div class="full-screen-dialog analytics prompts-analytics">
  <button class="floating-close-button" [mat-dialog-close]="sendAnalyticsToggleStateChanged">
    <i class="material-icons close-icon">close</i>
  </button>
  <div mat-dialog-title>Results for Display Nudges</div>
  <mat-dialog-content class="scrollable-container">
    <div class="row event-selector" *ngIf="data.analyticsData.events && data.analyticsData.events.length">
      <div class="col-md-3">
        <mat-form-field class="nxt-input" [floatLabel]="'always'" appearance="none">
          <mat-label> Select Goal </mat-label>
          <mat-select [(ngModel)]="selectedEvent" (ngModelChange)="onEventChange()">
            <mat-select-trigger class="small-icon">
              <mat-icon style="width: 16px; font-size: 1em;" *ngIf="selectedEvent.primary">flag</mat-icon>
              {{selectedEvent.name}}
            </mat-select-trigger>
            <mat-option *ngFor="let event of data.analyticsData.events" [value]="event">
              <mat-icon style="width: 16px; font-size: 1em;" *ngIf="event.primary">flag</mat-icon> {{event.name}}

              <span class="event-props" *ngIf="shouldShowSelectedEventTypeOrProp(event)">
                <ng-container *ngFor="let evRule of event.criteria.rules; let i=index;">
                  {{evRule.field}}{{ i === (event.criteria.rules.length - 1) ? ' ' : ',' }}
                </ng-container>
              </span>

            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-2 event-prop" *ngIf="shouldShowSelectedEventTypeOrProp(selectedEvent)">
        <p class="event-type">Event Type</p>
        <p class="event-criteria text-truncate">
          {{ selectedEvent.type && selectedEvent.type.label ? eventTypeMap[selectedEvent.type.label] : '' }} &nbsp;
        </p>
      </div>

      <div class="col-md-6 event-prop" *ngIf="shouldShowSelectedEventTypeOrProp(selectedEvent)">
        <p class="event-type">Event Properties</p>
        <p class="event-criteria text-truncate">
          <ng-container *ngFor="let rule of selectedEvent.criteria.rules; let i=index;">
            <ng-container *ngIf="rule.value">
              {{rule.field || rule.id}} {{ rule.operator }} {{rule.value}}
              <ng-container *ngIf="i !== (selectedEvent.criteria.rules.length - 1)">,
              </ng-container>
            </ng-container>
          </ng-container>
          &nbsp;
        </p>
      </div>
    </div>
    <div class="prompts-analytics-container">
      <div class="accord-container accord-row-header" *ngIf="!pageLoading">
        <div class="section-container sticky-header-container p-24">
          <div class="first-section accordion-header">Nudges</div>
          <div class="second-section section-3"
            [ngClass]="{'section-5': data.analyticsData.events && data.analyticsData.events.length}">
            <div class="accordion-header">Total Views</div>
            <div class="accordion-header">Unique Views</div>
            <div class="accordion-header">Dismissed</div>
            <ng-container *ngIf="selectedEvent">
              <div class="accordion-header">
                Attributed User Count
                <i class="material-icons icon tooltip"
                  matTooltip="Unique users who have seen the nudge as well as performed the goal event in the specified duration"
                  [matTooltipPosition]="'above'" matTooltipClass="above">
                  info
                </i>
              </div>
              <div class="accordion-header">Attributed Total Goal Events</div>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-container>
        <ng-container *ngFor="let promptElement of analyticsData; index as i">
          <div class="accord-container accord-body-row"
            [ngClass]="{'expanded-state': promptElement == expandedElement, 'last-row': i === analyticsData.length - 1, 'hover-state': promptElement !== expandedElement}">
            <div class="section-container p-24 pointer"
              [ngClass]="{'contains-bottom-border' : promptElement == expandedElement }"
              (click)="clickRow(promptElement)">
              <div class="first-section">
                {{(chartData && (chartData.lidx === promptElement.lidx) && chartData.title) ? chartData.title : promptElement.title}}
                ({{templateToNameMap[promptElement['template']]}})
              </div>
              <div class="second-section section-3"
                [ngClass]="{'section-5': data.analyticsData.events && data.analyticsData.events.length}"
                *ngIf="promptElement == expandedElement">
                <div class="second-section-content">
                  {{(chartData && (chartData.lidx === promptElement.lidx)  && chartData.hasOwnProperty('c_v')) ? chartData.c_v : 0}}
                </div>
                <div class="second-section-content">
                  {{(chartData && (chartData.lidx === promptElement.lidx) && chartData.hasOwnProperty('c_uv')) ? chartData.c_uv : 0}}
                </div>
                <div class="second-section-content">
                  {{(chartData && (chartData.lidx === promptElement.lidx)  && chartData.hasOwnProperty('c_d')) ? chartData.c_d : 0}}
                </div>
                <ng-container *ngIf="selectedEvent">
                  <div class="second-section-content">
                    {{(chartData && (chartData.lidx === promptElement.lidx)  && chartData.attr.hasOwnProperty('user_count')) ? chartData.attr.user_count : 0}}
                  </div>
                  <div class="second-section-content">
                    {{(chartData && (chartData.lidx === promptElement.lidx)  && chartData.attr.hasOwnProperty('event_count')) ? chartData.attr.event_count : 0}}
                  </div>
                </ng-container>
              </div>
            </div>
            <div class=" details-container wrapped-content" *ngIf="promptElement == expandedElement"
              [@detailExpand]="promptElement == expandedElement ? 'expanded' : 'collapsed'">
              <div class="accordion-body" *ngIf="!chartLoading">
                <div class="data-section">
                  <div class="chart-tooling">
                    <mat-form-field class="nxt-input" [floatLabel]="'always'" appearance="none">
                      <!-- SELECT TIME DURATION FOR RESULTS -->
                      <mat-label> Showing results for </mat-label>
                      <mat-select [(ngModel)]="selectedTimeOption"
                        (ngModelChange)="onTimeOptionChange(promptElement.lidx)">
                        <mat-option *ngFor="let timeOption of reportTimeOptions" [value]="timeOption">
                          {{timeOption.text}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <a class="download-report" mat-button [disabled]="isReportDownloadBtnDisabled(promptElement)"
                      matTooltip="{{getTooltipMessageForReportStatus(promptElement)}}" [matMenuTriggerFor]="reportMenu">
                      <mat-icon class="mat-icon material-icons">
                        file_download
                      </mat-icon>
                      <span class="download-text">DOWNLOAD CSV</span>
                    </a>
                    <mat-menu #reportMenu="matMenu">
                      <button mat-menu-item (click)="exportResultInCSVFormat(promptElement)">
                        <span>Download Summary Report</span>
                      </button>
                      <ng-container *ngIf="feedbackNudgeMap.hasOwnProperty(promptElement['template'])">
                        <button mat-menu-item (click)="generateRequestForReportDownload(promptElement)">
                          <span>Download User Level Report</span>
                        </button>
                      </ng-container>
                    </mat-menu>
                    <!-- <div class="nudge-id-data" *ngIf="showNudgeId">ID
                      {{data.analyticsData.journey_hash}}{{promptElement.lidx}}</div> -->
                    <div class="hansel-nudge-event">
                      <mat-checkbox (click)="showAnalyticsAlertDialog($event, chartData)"
                        [(ngModel)]="chartData.sendAnalyticsEvent">
                      </mat-checkbox>
                      <span class="text">
                        Send the event to Analytics provider
                        <a [href]="docLinks.analyticsEventListenerLinks[getSelectedAppOs()]" class="learn-more"
                          target="_blank">Learn
                          More</a>
                      </span>
                      <!-- <div class="nudge-event-text">
                        <span class="text">
                          "<span class="nudge-event">hansel_nudge_event</span>" will be sent
                        </span>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="chart-section">
                  <div class="chart-left-section">
                    <div *ngIf="showTotalViewsSubmissions(promptElement['template'])" class="view-details mb-3">
                      <div class="view-details-content" *ngIf="isKeyPresentInChartData(analyticsType)">
                        <div class="heading">Total Submissions</div>
                        <div class="views" [style.color]="lineChartColors[3]['borderColor']">
                          {{chartData['tdata'][getSubmissionCount(analyticsType)]}}
                        </div>
                      </div>
                    </div>

                    <div class="graph-container" *ngIf="chartData && chartData['tdata']">
                      <!-- tdata is template data -->
                      <div class="analytics-sidepane"
                        [ngClass]="{'adjust-margin': promptElement['template'] === 'newsletter_subscription' || promptElement['template'] === 'beta_test_signups' || promptElement['template'] === 'user_feedback'}">
                        <!-- BUTTON -->
                        <div *ngIf="analyticsType === 'Button'" class="btn-analytics">
                          <div *ngIf="hasButton('b1_ccount')" class="mb-3">
                            <p class="heading">{{getButtonLabel('b1_count', chartData['lidx'])}}</p>
                            <p class="views" [style.color]="lineChartColors[0]['borderColor']">
                              {{chartData['tdata']['b1_ccount']}}
                            </p>
                          </div>
                          <div *ngIf="hasButton('b2_ccount')" class="mb-3">
                            <p class="heading">{{getButtonLabel('b2_count', chartData['lidx'])}}</p>
                            <p class="views" [style.color]="lineChartColors[1]['borderColor']">
                              {{chartData['tdata']['b2_ccount']}}
                            </p>
                          </div>
                          <!-- VIEW RESULTS -->
                          <div *ngIf="!showTotalViewsSubmissions(promptElement['template'])" class="btn-analytics">
                            <div class="mb-3">
                              <p class="heading">Total Views</p>
                              <p class="views" [style.color]="lineChartColors[2]['borderColor']">
                                {{chartData['c_v']}}
                              </p>
                            </div>
                          </div>

                          <div class="feedback-container scrollable-container"
                            *ngIf="promptElement['template'] === 'newsletter_subscription' || promptElement['template'] === 'beta_test_signups' || promptElement['template'] === 'user_feedback'">
                            <div class="single-feedback" *ngFor="let item of chartData['tdata']['last5_reviews']">
                              <p class="feedback-text">
                                {{item['value']}}
                              </p>
                              <p class="right-text">
                                {{item['time']}}
                              </p>
                            </div>

                            <div class="no-feedback" *ngIf="!hasKeys(chartData['tdata']['last5_reviews'])">
                              <div class="heading"> No subscription info received </div>
                              <div class="text">Check back later to view submissions</div>
                            </div>

                            <!-- Download Feedback -->
                            <!-- <div class="download-feedback-btn-container">
                              <a [disabled]="isDilDownloadBtnDisabled(promptElement)"
                                matTooltip="{{getTooltipMessage(promptElement)}}" class="feedback-button" mat-button
                                (click)="onRequestDilData(promptElement)">
                                Download List
                              </a>
                            </div> -->
                          </div>

                        </div>
                        <!-- Download Feedback for Newsletter Subscriptions && Beta-Signups
                      <a class="feedback-button" mat-button (click) = "onDownloadFeedback(promptElement.lidx)" *ngIf="templateToNameMap[promptElement['template']] === 'Newsletter Subscription' || templateToNameMap[promptElement['template']] === 'Beta Test Signups'">Download Feedback</a>
                      -->

                        <!-- NPS -->
                        <div *ngIf="analyticsType === 'NPS' || analyticsType === 'NPS-with-user-feedback'"
                          class="nps-analytics">
                          <span class="nps-score">
                            {{calculateNpsScore(chartData['tdata'])}}
                          </span>
                          <span class="nps-score-text">
                            NPS Score
                          </span>
                          <div class="histogram nps-histogram">
                            <div class="histogram-content"
                              *ngFor="let item of ['prom_ccount', 'pass_ccount', 'detr_ccount']; let i = index">
                              <p class="outside-text">
                                {{chartData['tdata'][item]}} (

                                {{calculatePercentage(chartData['tdata'][item], sumOfNps(chartData['tdata']))}}%)
                              </p>
                              <div class="rectangle">
                                <p class="rectangle-text">{{labelsMap[item]}}</p>
                                <div class="filled" [style.backgroundColor]="lineChartColors[i]['borderColor']"
                                  [style.width.%]="calculatePercentage(chartData['tdata'][item], sumOfNps(chartData['tdata']))">
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--Download Feedback-->
                          <!-- <a [disabled]='true' class="feedback-button" matTooltip="Coming Soon" mat-button
                            *ngIf="analyticsType === 'NPS-with-user-feedback'">Download Feedback</a> -->
                          <!-- NPS SCORE LINK TO DOCUMENTATION-->
                          <div class="mt-3 link">
                            <a (click)="openDocs()">Learn how NPS
                              Score is calculated<i class="icon material-icons">
                                open_in_new
                              </i></a>
                          </div>
                        </div>
                        <div *ngIf="analyticsType === 'Rating' || analyticsType === 'Rating-with-user-feedback'"
                          class="rating-analytics">
                          <p class="star-text">
                            <span class="count-text">{{chartData['tdata']['cumul_average_rating']}}</span> Out of
                            {{chartData['tdata']['star_count']}}
                            Stars
                          </p>
                          <app-average-star-rating [maxCount]="chartData['tdata']['star_count']"
                            [averageRating]="chartData['tdata']['cumul_average_rating']" [chartData]="chartData">
                          </app-average-star-rating>
                          <div class="bottom-note">
                            Note - Rating scale has been changed midway. Average calculation may not be accurate
                          </div>
                          <div class="histogram rating-histogram">
                            <div class="histogram-content"
                              *ngFor="let item of getStarCountArray(chartData['tdata']); let i = index">
                              <p class="outside-text" [ngClass]="{'disabled': item.disabled}">
                                {{chartData['tdata']['sdata'][item.text] || 0}}%
                              </p>
                              <div class="rectangle">
                                <p class="rectangle-text" [ngClass]="{'disabled': item.disabled}">
                                  {{labelsMap[item.text]}}
                                </p>
                                <div class="filled" *ngIf="!item.disabled"
                                  style="background-image: linear-gradient(to left, #a3e1ff, #039be5);"
                                  [style.width.%]="chartData['tdata']['sdata'][item.text]">
                                </div>
                                <div class="filled" *ngIf="item.disabled"
                                  style="background-color: rgba(153, 153, 153, 0.21)"
                                  [style.width.%]="chartData['tdata']['sdata'][item.text]">
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--Download Feedback-->
                          <!-- <a [disabled]='true' class="feedback-button" mat-button matTooltip="Coming Soon"
                            *ngIf="analyticsType === 'Rating-with-user-feedback'">Download Feedback</a> -->
                        </div>

                        <!-- FEEDBACK -->
                        <div *ngIf="analyticsType === 'Feedback'" class="feedback-analytics">
                          <!-- VIEW RESULTS -->
                          <div *ngIf="!showTotalViewsSubmissions(promptElement['template'])" class="btn-analytics">
                            <div class="mb-3">
                              <p class="heading">Total Views</p>
                              <p class="views" [style.color]="lineChartColors[2]['borderColor']">
                                {{chartData['c_v']}}
                              </p>
                            </div>
                          </div>
                          <!-- Last 5 Feedback -->
                          <div class="feedback-container scrollable-container">
                            <div class="single-feedback" *ngFor="let item of chartData['tdata']['last5_reviews']">
                              <p class="feedback-text">
                                {{item['value']}}
                              </p>
                              <p class="right-text">
                                {{item['time']}}
                              </p>
                            </div>
                            <div class="no-feedback" *ngIf="!hasKeys(chartData['tdata']['last5_reviews'])">
                              <div class="heading"> No User Feedback Received </div>
                              <div class="text">Check back later to view submissions</div>
                            </div>
                            <!-- Download Feedback -->
                            <!-- <div class="download-feedback-btn-container">
                              <a [disabled]="isDilDownloadBtnDisabled(promptElement)"
                                matTooltip="{{getTooltipMessage(promptElement)}}" class="feedback-button" mat-button
                                (click)="onRequestDilData(promptElement)">
                                Download Feedback
                              </a>
                            </div> -->
                          </div>
                        </div>

                        <!-- MULTI -->
                        <div *ngIf="analyticsType === 'Multi'" class="multi-analytics">
                          <div class="multi-choice-container text-truncate"
                            *ngFor="let item of getKeys(chartData['tdata']['count'])">
                            <p class="title-text text-truncate" matTooltip="{{item}}"
                              [matTooltipDisabled]="item.length < 30">
                              {{item}}</p>
                            <p class="number-text text-truncate">
                              {{chartData['tdata']['count'][item]}}
                              ({{calculatePercentage(chartData['tdata']['count'][item], sumOfMultiChoice(chartData['tdata']))}}%)
                            </p>
                          </div>
                        </div>
                        <!-- VIEWS ONLY -->
                        <div *ngIf="analyticsType === 'View' && !showTotalViewsSubmissions(promptElement['template'])"
                          class="
                        btn-analytics">
                          <div class="mb-3">
                            <p class="heading">Total Views</p>
                            <p class="views" [style.color]="lineChartColors[0]['borderColor']">
                              {{chartData['c_v']}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- GRAPH -->
                  <div class="chart-container">
                    <canvas class="canvas-style" baseChart [datasets]="lineChartData" [labels]="lineChartLabels"
                      [options]="lineChartOptions" [colors]="lineChartColors" [legend]="true"
                      [chartType]="chartType"></canvas>
                  </div>
                </div>
              </div>
              <div class="animate-flicker" *ngIf="chartLoading" style="position: relative; height: 300px">
                <div class="align-absolute-center">
                  <img src="/assets/images/Loader-PX.svg" class="px-loader">
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="animate-flicker" *ngIf="pageLoading" style="position: relative; height: 300px">
      <div class="align-absolute-center">
        <img src="/assets/images/Loader-PX.svg" class="px-loader">
      </div>
    </div>

    <div class="bottom-note" *ngIf="!pageLoading">
      Note: Results might take up to one hour to be in sync
    </div>
  </mat-dialog-content>
</div>
